import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'
import { ToasterModule } from '../../shared/toaster/toaster.module'
import { AppAccountsService } from './app-accounts.service'
import { AppEffects } from './app.effects'
import * as fromApp from './app.reducer'
import { AppsService } from './apps.service'

@NgModule({
  providers: [AppAccountsService, AppsService],
  imports: [
    StoreModule.forFeature(fromApp.appFeatureKey, fromApp.reducer),
    EffectsModule.forFeature([AppEffects]),
    ToasterModule,
  ],
})
export class AppsModule {}
